import { Link } from "react-router-dom";
import type { VideoItem } from "@/mocks/videos";
import { categories } from "@/mocks/videos";

function catName(id: string) {
  return categories.find((c) => c.id === id)?.name || "吃瓜视频";
}

export default function VideoCard({ video, rank }: { video: VideoItem; rank?: number }) {
  return (
    <Link
      to={`/video/${video.id}`}
      className="group block bg-background-50 border border-background-200 rounded-xl overflow-hidden hover:-translate-y-1 transition-transform duration-300"
    >
      <div className="relative overflow-hidden">
        <img
          src={video.cover}
          alt={video.title}
          className="w-full h-40 md:h-44 object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <span className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-black/60 text-background-50 text-xs">
          <i className="ri-time-line mr-0.5"></i>
          {video.duration}
        </span>
        {typeof rank === "number" && rank <= 3 && (
          <span className="absolute top-2 left-2 inline-flex w-6 h-6 items-center justify-center rounded-md bg-primary-500 text-background-50 text-sm font-black">
            {rank}
          </span>
        )}
        <span className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
          <span className="inline-flex w-12 h-12 items-center justify-center rounded-full bg-primary-500/90 text-background-50">
            <i className="ri-play-fill text-xl"></i>
          </span>
        </span>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="text-sm md:text-base font-bold text-foreground-950 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
          {video.title}
        </h3>
        <div className="mt-2.5 flex items-center justify-between text-xs text-foreground-500">
          <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-900">
            {catName(video.category)}
          </span>
          <span className="inline-flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {video.views}
          </span>
        </div>
      </div>
    </Link>
  );
}